var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"searchable":true,"label":_vm.label,"placeholder":_vm.placeholder,"clearable":_vm.clearable,"disabled":_vm.disabled},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }